"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapContextMenu = void 0;
var ContextMenu = require("ol-contextmenu");
var olProj = require("ol/proj");
var Vector_1 = require("ol/layer/Vector");
var Vector_2 = require("ol/source/Vector");
var Feature_1 = require("ol/Feature");
var Style_1 = require("ol/style/Style");
var Fill_1 = require("ol/style/Fill");
var Point_1 = require("ol/geom/Point");
var Stroke_1 = require("ol/style/Stroke");
var Icon_1 = require("ol/style/Icon");
var Text_1 = require("ol/style/Text");
var MapContextMenu = /** @class */ (function () {
    function MapContextMenu(_textPack, iconUrl) {
        var _this = this;
        if (iconUrl === void 0) { iconUrl = "/images/pin_drop.png"; }
        this._textPack = _textPack;
        this.iconUrl = iconUrl;
        this._initialised = false;
        this.addToMap = function (map) {
            _this.init(map);
        };
        this.init = function (map) {
            if (!_this._initialised) {
                var self_1 = _this;
                self_1._map = map;
                self_1._map.olMap.addLayer(self_1._vectorLayer);
                self_1._items = [
                    '-',
                    {
                        text: "<i class=\"fa fa-crosshairs\" aria-hidden=\"true\"></i>" + _this._textPack.centerMapHere,
                        callback: function (obj) {
                            self_1.centerMap([obj.coordinate[0], obj.coordinate[1]]);
                        }
                    },
                    {
                        text: "<i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>" + _this._textPack.addAMarker,
                        callback: function (obj) {
                            self_1.addMarker([obj.coordinate[0], obj.coordinate[1]]);
                        }
                    }
                ];
                self_1._removeMarkerItem = {
                    text: "<i class=\"fa fa-trash\" aria-hidden=\"true\"></i" + _this._textPack.removeMarker,
                    classname: 'marker',
                    callback: function (obj) {
                        self_1.removeMarker(obj.data.marker);
                    }
                };
                self_1._contextMenu = new ContextMenu({
                    width: 170,
                    defaultItems: true,
                    items: self_1._items
                });
                self_1._contextMenu.on('beforeopen', function (evt) {
                    var element = map.olMap.getTargetElement();
                    var _a = element.getBoundingClientRect(), top = _a.top, left = _a.left;
                    //EDGE does not support document.elementsFromPoint
                    if (document.elementsFromPoint && document.elementsFromPoint(evt.pixel[0] + left, evt.pixel[1] + top).some(function (e) { return e.id === 'popup'; })) {
                        self_1._contextMenu.disable();
                        return;
                    }
                });
                self_1._contextMenu.getDefaultItems()[0].text = _this._textPack.zoomIn;
                self_1._contextMenu.getDefaultItems()[1].text = _this._textPack.zoomOut;
                self_1._contextMenu.on('open', function (evt) {
                    var feature = self_1._map.olMap.forEachFeatureAtPixel(evt.pixel, function (ft, l) {
                        return ft;
                    });
                    if (feature && feature.get('type') === 'removable') {
                        self_1._contextMenu.clear();
                        self_1._removeMarkerItem.data = {
                            marker: feature
                        };
                        self_1._contextMenu.push(self_1._removeMarkerItem);
                    }
                    else {
                        self_1._contextMenu.clear();
                        self_1._contextMenu.extend(self_1._contextMenu.getDefaultItems());
                        self_1._contextMenu.extend(self_1._items);
                    }
                });
                self_1._map.olMap.addControl(self_1._contextMenu);
                self_1._initialised = true;
            }
        };
        this.addItems = function (items) {
            _this._contextMenu.extend(items);
            _this._items = _this._items.concat(items);
        };
        this.centerMap = function (coordinate) {
            _this._map.olMap.getView().animate({ center: coordinate });
        };
        this.addMarker = function (coordinate) {
            var template = 'Coordinate is ({x} | {y})', iconStyle = new Style_1.default({
                image: new Icon_1.default({ scale: .6, src: _this.iconUrl }),
                text: new Text_1.default({
                    offsetY: 25,
                    text: _this.getGridRef(coordinate),
                    font: '15px Open Sans,sans-serif',
                    fill: new Fill_1.default({ color: '#111' }),
                    stroke: new Stroke_1.default({ color: '#eee', width: 2 })
                })
            }), feature = new Feature_1.default({
                type: 'removable',
                geometry: new Point_1.default(coordinate)
            });
            feature.setStyle(iconStyle);
            _this._vectorLayer.getSource().addFeature(feature);
        };
        this.getGridRef = function (coordinate) {
            //transform from display projection to data projection
            var coords = olProj.transform(coordinate, _this._map.options.displayProjection, _this._map.options.dataProjection);
            return coords[0].toFixed(0) + " " + coords[1].toFixed(0);
        };
        this.removeMarker = function (marker) {
            _this._vectorLayer.getSource().removeFeature(marker);
        };
        this._vectorLayer = new Vector_1.default({ source: new Vector_2.default() });
    }
    return MapContextMenu;
}());
exports.MapContextMenu = MapContextMenu;
//# sourceMappingURL=MapContextMenu.js.map